import { render, staticRenderFns } from "./ImageStripe.vue?vue&type=template&id=c1a1e1b8&"
import script from "./ImageStripe.vue?vue&type=script&lang=js&"
export * from "./ImageStripe.vue?vue&type=script&lang=js&"
import style0 from "./ImageStripe.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports